import {
  Button,
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useGrades } from '../grades/Grades';
import { useInstitutions } from '../institutions/Institutions';
import { useSeries } from '../series/Series';

const useStyles = makeStyles((theme) => ({
  input: {
    marginTop: '20px',
  },
}));

function useForm() {
  const [entries, setEntries] = useState({});

  const handleChange = (e) => {
    if (e.target.name === 'type' && e.target.value === 'standard') {
      setEntries({
        ...entries,
        [e.target.name]: e.target.value,
        series: null,
      });
    } else {
      setEntries({
        ...entries,
        [e.target.name]: e.target.value,
      });
    }
  };

  return {
    handleChange,
    entries,
  };
}

// Download a txt with pines
function downloadResult(result) {
  if (result instanceof Array) {
    let text = '';
    result.forEach((pin) => {
      text += `${pin.pin}\n`;
    });
    const element = document.createElement('a');
    const file = new Blob([text], { type: 'text/plain' });
    element.href = URL.createObjectURL(file);
    element.download = 'pines.txt';
    document.body.appendChild(element);
    element.click();
    return;
  }

  const element = document.createElement('a');
  const file = new Blob([result.pin], { type: 'text/plain' });
  element.href = URL.createObjectURL(file);
  element.download = 'pines.txt';
  document.body.appendChild(element);
  element.click();
}

export function CreatePin(props) {
  const classes = useStyles();
  const { handleChange, entries } = useForm();
  const { series } = useSeries();
  const { grades } = useGrades();
  const { institutions } = useInstitutions();
  const navigate = useNavigate();

  const handleCreate = async () => {
    const response = await fetch('https://api.edicionesmilenio.com/api/pines', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ ...entries, usesQuantityLeft: 1 }),
    });
    if (response.status === 201) {
      const json = await response.json();
      downloadResult(json?.data);
      navigate('/admin/pines');
    } else {
      let json = await response.json();
      alert(json.message);
    }
  };

  return (
    <div
      style={{
        width: '100%',
        paddingLeft: '20px',
        paddingRight: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <p
        style={{
          width: '100%',
          color: '#888',
          marginBottom: '50px',
          alignSelf: 'center',
          justifySelf: 'center',
          textAlign: 'center',
        }}
      >
        Estimado administrador, desde esta sección podrás crear nuevos pines
        para la plataforma, siempre y cuando se cuente con la plena autorización
        de la gerencia de Ediciones Milenio, esta herramienta permite crear
        pines estándar y maestros, que permiten activar un libro o varios según
        el modelo de negocio, además permiten tener una fecha de vencimiento
        para su uso. Al realizar cada tanda de generación, el sistema descargará
        automáticamente el archivo plano en formato TXT para su operación y
        manejo.
      </p>
      <div
        style={{
          width: '100%',
          paddingLeft: '20px',
          paddingRight: '20px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <TextField
          className={classes.input}
          label="Cantidad de pines"
          variant="outlined"
          name="quantity"
          onChange={handleChange}
          value={entries?.quantity}
        />
        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="type-label">Tipo de pin</InputLabel>
          <Select
            labelId="type-label"
            id="type"
            name="type"
            value={entries?.type || ''}
            onChange={handleChange}
            label="Tipo de pin"
          >
            <MenuItem value={'standard'}>Estandar</MenuItem>
            <MenuItem value={'master'}>Maestro</MenuItem>
          </Select>
        </FormControl>
        {!(entries?.type === 'master' || entries?.type === undefined) ? (
          <FormControl variant="outlined" className={classes.input}>
            <InputLabel id="series-label">Series</InputLabel>
            <Select
              labelId="series-label"
              id="series"
              name="series"
              value={entries?.series}
              onChange={handleChange}
              label="Series"
            >
              {series.map((serie) => (
                <MenuItem value={serie?._id}>{serie?.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
        ) : (
          <FormControl variant="outlined" className={classes.input}>
            <InputLabel id="series-label">Series</InputLabel>
            <Select
              labelId="series-label"
              id="series"
              name="series"
              value={[].concat(entries?.series || [])}
              onChange={handleChange}
              label="Series"
              multiple={true}
            >
              {series.map((serie) => (
                <MenuItem value={serie?._id}>{serie?.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="grade-label">Grado</InputLabel>
          <Select
            labelId="grade-label"
            id="grade"
            name="grade"
            value={entries?.grade}
            onChange={handleChange}
            label="Grado"
          >
            {grades.map((grade) => (
              <MenuItem value={grade?._id}>{grade?.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="institution-label">Institución</InputLabel>
          <Select
            labelId="institution-label"
            id="institution"
            name="institution"
            value={entries?.institution}
            onChange={handleChange}
            label="Institución"
          >
            {institutions.map((institution) => (
              <MenuItem value={institution?._id}>{institution?.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl className={classes.input}>
          <span style={{ color: '#777' }}>Fecha de expiración</span>
          <TextField
            variant="outlined"
            name="expirationDate"
            onChange={handleChange}
            value={entries?.expirationDate}
            type={'date'}
          />
        </FormControl>
        <Button
          variant="contained"
          color="primary"
          className={classes.input}
          disabled={
            !(
              entries?.quantity &&
              entries?.series &&
              entries?.type &&
              entries?.grade &&
              entries?.institution &&
              entries?.expirationDate
            )
          }
          onClick={handleCreate}
        >
          Crear Pin
        </Button>
      </div>
    </div>
  );
}
